// TAM AI - Shared AI API Utility
// Uses Lovable Cloud backend function for secure AI calls

import { supabase } from '@/integrations/supabase/client';

export async function callTAMAI(prompt: string, options?: {
  temperature?: number;
  maxTokens?: number;
}): Promise<string> {
  const { temperature = 0.7, maxTokens = 2048 } = options || {};

  const { data, error } = await supabase.functions.invoke('ai-chat', {
    body: { prompt, temperature, maxTokens },
  });

  if (error) {
    console.error('[TAM AI] Edge function error:', error);
    throw new Error(error.message || 'AI service temporarily unavailable. Please try again.');
  }

  if (data?.error) {
    console.error('[TAM AI] API error:', data.error);
    throw new Error(data.error);
  }

  if (!data?.result) {
    throw new Error('No response from AI service.');
  }

  return data.result;
}

// Parse JSON from AI response (handles markdown code blocks)
export function parseAIJSON<T>(response: string): T {
  // Remove markdown code blocks if present
  let cleaned = response
    .replace(/```json\s*/gi, '')
    .replace(/```\s*/gi, '')
    .trim();

  // Try to extract JSON object
  const jsonMatch = cleaned.match(/\{[\s\S]*\}/);
  if (jsonMatch) {
    cleaned = jsonMatch[0];
  }

  return JSON.parse(cleaned);
}
